import React, {ReactElement} from 'react';
import {AdornedText} from 'ui/components/AdornedText';
import {NewTabLink} from 'components/NewTabLink';
import {Text} from 'components/Text';

export const Promo = (): ReactElement => (
  <Text data-test='promo'>
    <NewTabLink href='https://t.me/tzlvt/82'>
      <AdornedText>Размораживаем Тяжеловато и&nbsp;Койн</AdornedText>
    </NewTabLink>
    <br />
    Подробности раз в неделю у нас в телеграм-канале
  </Text>
);
